module.exports = __webpack_public_path__ + "img/icon-star5.0f96c202.png";